import { defineMessages } from 'react-intl.macro';

import { PspiObsahEnum } from '../../openapi/types/PspiObsahEnum';
import { StatusZadateleEnum } from '../../openapi/types/StatusZadateleEnum';

export const epsiOrderMessages = defineMessages({
  listTitle: {
    id: 'vydej.epsiOrder.listTitle',
    defaultMessage: 'Přehled žádostí o výdej EPSI',
  },
  listDescription: {
    id: 'vydej.epsiOrder.listDescription',
    defaultMessage:
      'Žádosti o výdej PSPI přijaté z IS DMVS. Data drží a vydává IS DMVS, zde se žádosti pouze schvalují.',
  },
  columnNumber: {
    id: 'vydej.epsiOrder.columnNumber',
    defaultMessage: 'Číslo',
  },
  columnState: {
    id: 'vydej.epsiOrder.columnState',
    defaultMessage: 'Stav',
  },
  columnIdPodani: {
    id: 'vydej.epsiOrder.columnIdPodani',
    defaultMessage: 'ID podání DMVS',
  },
  columnZadatel: {
    id: 'vydej.epsiOrder.columnZadatel',
    defaultMessage: 'Žadatel',
  },
  columnStatusZadatele: {
    id: 'vydej.epsiOrder.columnStatusZadatele',
    defaultMessage: 'Status žadatele',
  },
  columnPspiObsah: {
    id: 'vydej.epsiOrder.columnPspiObsah',
    defaultMessage: 'Obsah PSPI',
  },
  columnDatumPlatnosti: {
    id: 'vydej.epsiOrder.columnDatumPlatnosti',
    defaultMessage: 'Datum platnosti',
  },
  columnCreated: {
    id: 'vydej.epsiOrder.columnCreated',
    defaultMessage: 'Vytvořeno',
  },
  listStateWaiting: {
    id: 'vydej.epsiOrder.listStateWaiting',
    defaultMessage: 'Načítají se žádosti o výdej EPSI...',
  },
  listStateFail: {
    id: 'vydej.epsiOrder.listStateFail',
    defaultMessage: 'Žádosti o výdej EPSI se nepodařilo načíst.',
  },
  listStateEmpty: {
    id: 'vydej.epsiOrder.listStateEmpty',
    defaultMessage: 'Nebyly nalezeny žádné žádosti o výdej EPSI.',
  },
  listStateFilteredEmpty: {
    id: 'vydej.epsiOrder.listStateFilteredEmpty',
    defaultMessage: 'Zvolenému filtru neodpovídá žádná žádost o výdej EPSI.',
  },
  attachmentTooltip: {
    id: 'vydej.epsiOrder.attachmentTooltip',
    defaultMessage: 'Žádost obsahuje přílohu',
  },

  detailTitle: {
    id: 'vydej.epsiOrder.detailTitle',
    defaultMessage: 'Žádost o výdej EPSI č. {id}',
  },
  detailStateWaiting: {
    id: 'vydej.epsiOrder.detailStateWaiting',
    defaultMessage: 'Načítá se detail žádosti o výdej EPSI...',
  },
  detailStateFail: {
    id: 'vydej.epsiOrder.detailStateFail',
    defaultMessage: 'Detail žádosti o výdej EPSI se nepodařilo načíst.',
  },

  sectionRequest: {
    id: 'vydej.epsiOrder.sectionRequest',
    defaultMessage: 'Žádost',
  },
  sectionPurpose: {
    id: 'vydej.epsiOrder.sectionPurpose',
    defaultMessage: 'Účel výdeje',
  },
  sectionApplicant: {
    id: 'vydej.epsiOrder.sectionApplicant',
    defaultMessage: 'Žadatel',
  },
  sectionDecision: {
    id: 'vydej.epsiOrder.sectionDecision',
    defaultMessage: 'Vyřízení',
  },
  sectionFiles: {
    id: 'vydej.epsiOrder.sectionFiles',
    defaultMessage: 'Soubory',
  },
  sectionFilesDocs: {
    id: 'vydej.epsiOrder.sectionFilesDocs',
    defaultMessage: 'Výdejové',
  },
  sectionAttachment: {
    id: 'vydej.epsiOrder.sectionAttachment',
    defaultMessage: 'Příloha',
  },
  sectionAreas: {
    id: 'vydej.epsiOrder.sectionAreas',
    defaultMessage: 'Územní vymezení',
  },

  ucelKod: {
    id: 'vydej.epsiOrder.ucelKod',
    defaultMessage: 'Kód účelu',
  },
  ucelTextem: {
    id: 'vydej.epsiOrder.ucelTextem',
    defaultMessage: 'Účel slovně',
  },
  pravniPredpisKod: {
    id: 'vydej.epsiOrder.pravniPredpisKod',
    defaultMessage: 'Kód právního předpisu',
  },
  jmeno: {
    id: 'vydej.epsiOrder.jmeno',
    defaultMessage: 'Název / jméno',
  },
  ico: {
    id: 'vydej.epsiOrder.ico',
    defaultMessage: 'IČO',
  },
  adresa: {
    id: 'vydej.epsiOrder.adresa',
    defaultMessage: 'Adresa',
  },
  idSubjektu: {
    id: 'vydej.epsiOrder.idSubjektu',
    defaultMessage: 'ID subjektu',
  },
  approver: {
    id: 'vydej.epsiOrder.approver',
    defaultMessage: 'Vyřídil',
  },
  decided: {
    id: 'vydej.epsiOrder.decided',
    defaultMessage: 'Datum vyřízení',
  },
  rejectionReason: {
    id: 'vydej.epsiOrder.rejectionReason',
    defaultMessage: 'Důvod zamítnutí',
  },
  attachmentEmpty: {
    id: 'vydej.epsiOrder.attachmentEmpty',
    defaultMessage: 'Žádost nemá žádnou přílohu.',
  },
  areasEmpty: {
    id: 'vydej.epsiOrder.areasEmpty',
    defaultMessage: 'Žádost nemá vyplněné územní vymezení.',
  },

  approveBtn: {
    id: 'vydej.epsiOrder.approveBtn',
    defaultMessage: 'Schválit',
  },
  rejectBtn: {
    id: 'vydej.epsiOrder.rejectBtn',
    defaultMessage: 'Zamítnout',
  },
  approveDialogText: {
    id: 'vydej.epsiOrder.approveDialogText',
    defaultMessage: 'Opravdu chcete žádost o výdej EPSI schválit?',
  },
  closeDialogBtn: {
    id: 'vydej.epsiOrder.closeDialogBtn',
    defaultMessage: 'Zavřít',
  },
  approveFail: {
    id: 'vydej.epsiOrder.approveFail',
    defaultMessage: 'Žádost se nepodařilo vyřídit.',
  },
  downloadFail: {
    id: 'vydej.epsiOrder.downloadFail',
    defaultMessage: 'Soubor se nepodařilo stáhnout.',
  },
});

export const pspiObsahMessages = defineMessages<PspiObsahEnum>({
  [PspiObsahEnum.KOMPLETNI]: {
    id: 'vydej.epsiOrder.pspiObsah.kompletni',
    defaultMessage: 'Kompletní data PSPI',
  },
  [PspiObsahEnum.VEREJNE_FINANCOVANI]: {
    id: 'vydej.epsiOrder.pspiObsah.verejneFinancovani',
    defaultMessage: 'PSPI z veřejných zdrojů',
  },
});

export const statusZadateleMessages = defineMessages<StatusZadateleEnum>({
  [StatusZadateleEnum.OPRAVNENY_ZADATEL]: {
    id: 'vydej.epsiOrder.statusZadatele.opravnenyZadatel',
    defaultMessage: 'Oprávněný žadatel',
  },
  [StatusZadateleEnum.VLASTNIK_SPRAVCE_PROVOZOVATEL]: {
    id: 'vydej.epsiOrder.statusZadatele.vlastnikSpravceProvozovatel',
    defaultMessage: 'Vlastník / správce / provozovatel',
  },
  [StatusZadateleEnum.AZI]: {
    id: 'vydej.epsiOrder.statusZadatele.azi',
    defaultMessage: 'AZI',
  },
  [StatusZadateleEnum.ZADATEL_DLE_ZADOSTI]: {
    id: 'vydej.epsiOrder.statusZadatele.zadatelDleZadosti',
    defaultMessage: 'Žadatel dle žádosti',
  },
  [StatusZadateleEnum.ORGAN_VEREJNE_MOCI]: {
    id: 'vydej.epsiOrder.statusZadatele.organVerejneMoci',
    defaultMessage: 'Orgán veřejné moci',
  },
  [StatusZadateleEnum.VLASTNIK_DOTCENYCH_NEMOVITOSTI]: {
    id: 'vydej.epsiOrder.statusZadatele.vlastnikDotcenychNemovitosti',
    defaultMessage: 'Vlastník dotčených nemovitostí',
  },
});
